<mt-button
  (submitEvent)="goToContact()"
  [outline]="true"
  [buttonStyle]="'secondary'"
  text="Contact us"
></mt-button>
@if (currentUser()) {
  <p>Welcome, {{ currentUser()?.name }}</p>
}
<mt-button (submitEvent)="logout()">Logout</mt-button>
